import authService from '../components/api-authorization/AuthorizeService'
import MembershipTypeViewModel from '../models/membershipTypes/MembershipTypeViewModel';

export default class MembershipTypeController {
    async List() : Promise<MembershipTypeViewModel[] | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('membershipType/List', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
}